import React, { useRef, useCallback, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Button, Input, Select, Form, ToggleSwitch } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Grid, Box } from '@mui/material';
import IconPicker from 'Modules/.common/components/IconPicker';
import { NotificationManager } from 'Components/Notifications';
import Tabs, { TabContainer } from 'Components/Tabs';
import { OrderData } from 'Core/data/Helpers';
import { convertWhiteColor } from 'Core/data/Helpers'
import { findColor } from 'Components/Map/utils'

//actions
import {
    clearRedux,
    mapLandmarkBulkOpenModal,
    mapLandmarksBulkUpdate,
    mapGetLandmarkTagsToCreate,
    mapGetLandmarkTags
} from 'Redux/actions';

const LandmarkBulk = (props) => {

    const { intl, mapRef } = props;
    const { messages } = intl;

    const [formData, setFormData] = useState({ color: '8677D9' });
    const [groups, setGroups] = useState([]);
    const dispatch = useDispatch();
    const editLandmarkBulk = useRef();

    const {
        open,
        landmarksToBulk,
        loadingLandmarkBulk,
        response
    } = useSelector((state) => state.realtimeMapLandmarkBulkModuleRedux);

    const { landmarkTagsToCreate: landmarkTags, landmarkTagsToCreateLoading: landmarkTagsLoading } = useSelector((state) => state.realtimeMapLandmarkListModuleRedux);

    useEffect(()=> {
        dispatch(mapGetLandmarkTagsToCreate())
    },[])

    useEffect(()=> {
        if(open && landmarkTags && landmarkTags.length > 0){
            let groupsList = []
            landmarkTags.forEach((group)=> {
                groupsList.push({
                    ...group, 
                    count: 0,
                    countDefault: 0,
                    color : !group.color ? '#DEDEDE' : convertWhiteColor(group.color),
                    default: true
                })
            })

            if(landmarksToBulk){
                groupsList = loadLandmarkGroups(groupsList)                
                setFormData({ ...formData, landmarkIds: landmarksToBulk.map((item) => item.id) })
            }
                

            setGroups(groupsList)
        }
    }, [landmarkTags, landmarksToBulk])

    useEffect(()=> {
        if(response){
            NotificationManager.success(
                messages['mapLandmarkBulk_landmark'],
                messages['success'],
                3000,
                null,
                null,
                'success',
            );
            dispatch(mapLandmarkBulkOpenModal(false))
        }
    },[response])


    const loadLandmarkGroups = (groupsList) => {

        let listResponse = [...groupsList]
        landmarksToBulk.forEach((landmark) => {
            const { tagsId } = landmark
            if(tagsId){
                const splitGroups = tagsId.split(',')

                splitGroups.forEach((group) => {
                    let listElement = listResponse.find((item) => item.id == parseInt(group))
                    if(listElement){
                        const countElements = listElement.count + 1
                        listElement.count = countElements
                        listElement.countDefault = countElements
                    }    
                })
                
            }    
        })
        
        listResponse = listResponse.map((group) => {
            if(group.count > 0){
                return {
                    ...group,
                    name: `${group.label} (${group.count})`,
                    default: false
                }
            }
            return group
            
        })
        return listResponse
            
    }

    const removeOfList = (newList) => {
        const idsToActive = newList.map((item) => item.id)
        const newListToReturn = groups.map((item) => {
            if(!idsToActive.includes(item.id)){
                return {
                    ...item,
                    name: item.label,
                    count : 0,
                    default: true
                }
            }else{
                if(item.count == 0)
                    return {
                        ...item,
                        name: `${item.label} (${landmarksToBulk.length})`,
                        count: landmarksToBulk.length,
                        default: false
                    }
                return {
                    ...item,
                    name: `${item.label} (${item.count})`,
                    default: false
                }
            }
        })
        setGroups(newListToReturn)
    }

    const handleClose = () => {
        dispatch(mapLandmarkBulkOpenModal(false));
    }

    const onSubmit = useCallback(() => {
        
        const updateBulk = []

        //get the deleted groups
        const getDeletedElements = groups.filter((item) => item.count == 0 && item.countDefault > 0);
        
        getDeletedElements.forEach((group) => {
            updateBulk.push({
                tagId: group.id, 
                name: group.name,
                entityName: 'Landmark', 
                entityIds: landmarksToBulk.map((item) => item.id), 
                action: 'Delete'
            })
        })

        groups.forEach((group) => {
            if(!group.default && group.count != group.countDefault)
                updateBulk.push({
                    tagId: group.id, 
                    name: group.name,
                    entityName: 'Landmark', 
                    entityIds: landmarksToBulk.map((item) => item.id), 
                    action: 'Create'
                })
        })
        
        dispatch(mapLandmarksBulkUpdate(updateBulk, formData && (formData.color || formData.iconName) ? formData : null))
        dispatch(mapGetLandmarkTags())
    })

    return (
        <Modal
            title={`${messages['mapLandmarkBulk_title']} - ${landmarksToBulk.length} ${messages['mapLandmarkBulk_landmark_selected']}`}
            open={open}
            loading={loadingLandmarkBulk || landmarkTagsLoading}
            position="right"
            size="small"
            className="modal-top-0"
            headerStyle={{
                top: 0
            }}
            handleClose={handleClose}
        >
            <ModalBody>
                <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>
                    <Form ref={editLandmarkBulk} onValidSubmit={onSubmit}>
                        <div style={{ marginBottom: 12 }}>    
                            <React.Fragment>
                                <div style={{ width: '100%' }}>
                                    <Grid
                                        container
                                        /* wrap="nowrap" */
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                    >
                                        
                                        <Grid item xs={9}>
                                            <div style={{ padding: '8px 0px 10px 0px' }}>
                                                <label style={{ marginRight: 10, fontWeight: 'bold' }}>
                                                    {messages['mapLandmarkBulk_iconType']}
                                                </label>
                                            </div>    
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div style={{marginLeft: 'auto', marginRight: 0}}>
                                                <ToggleSwitch
                                                    id="landmarkIcon"
                                                    name="landmarkIcon"
                                                    large
                                                    mapToggle
                                                    optionLabels={[messages['mapLandmarkBulk_custom'], messages['mapLandmarkBulk_custom']]}
                                                    checked={formData?.landmarkIcon || false}
                                                    onChange={(value) => setFormData({ ...formData, landmarkIcon: value })}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs={11}>
                                            <div style={{ padding: '22px 0px 10px 0px' }}>
                                                <label style={{ fontWeight: 'bold' }}>
                                                    {messages['mapLandmarkBulk_Icon_color']}
                                                </label>
                                            </div>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <div className="form-item">
                                                <IconPicker
                                                    color={convertWhiteColor(formData.color).replace('#', '')}
                                                    icon={formData?.iconName}
                                                    options={formData?.landmarkIcon ? ["color", "icon"] : ["color"]}
                                                    onChange={(color, icon) => setFormData({ ...formData, color: findColor(color), iconName: icon })}
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <div style={{ padding: '22px 0px 10px 0px' }}>
                                                <label>
                                                    {messages['mapLandmarkBulk_selectedLandmarks']}
                                                </label>
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Select
                                                id="groupsLandmarkBulk"
                                                label={messages["mapLandmarkBulk_tag"]}
                                                placeholder={messages["select"]}
                                                options={groups.filter((item) => item.default) || []}
                                                valueField="id"
                                                textField="name"
                                                onChange={(value) => {
                                                    let groups = value || [];
                                                    removeOfList(groups);
                                                }}
                                                value={groups.filter((item) => !item.default) || []}
                                                multiple
                                                selectedOptionsBelow
                                                required
                                                requiredMessage={messages["required_field"]}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </React.Fragment>
                        </div>
                    </Form>
                </div>
            </ModalBody>

            <ModalFooter style={{ bottom: 50 }}>
                <Button
                    disabled={loadingLandmarkBulk || landmarkTagsLoading}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingLandmarkBulk || landmarkTagsLoading}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        editLandmarkBulk.current.submit();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )

}

export default injectIntl(LandmarkBulk);